import React from "react";

/** Shared navy accent color for public-facing pages (case files, hearing link redirect). */
export const NAVY = "#172639";

/** Full-height centered container shared by public-facing pages (case files, hearing link redirect). */
export default function PageCenter({ children, background = "#f4f6f8", fontFamily = "Poppins, sans-serif" }) {
  return (
    <div style={{ minHeight: "100vh", background, display: "flex", alignItems: "center", justifyContent: "center", fontFamily }}>
      {children}
    </div>
  );
}
